import { Label } from '@/components/ui/label'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'

export type Workflow = 'router' | 'standard' | 'advanced'

interface WorkflowSelectorProps {
  value: Workflow
  onChange: (workflow: Workflow) => void
  disabled?: boolean
}

const WORKFLOWS: { value: Workflow; label: string; description: string }[] = [
  {
    value: 'router',
    label: 'Router (Recommended)',
    description: 'Auto-detects file type and routes to appropriate workflow',
  },
  {
    value: 'standard',
    label: 'Standard',
    description: 'Direct extraction without advanced classification',
  },
  {
    value: 'advanced',
    label: 'Advanced Classification',
    description: 'Full phenotype detection and specialized extraction',
  },
]

export function WorkflowSelector({ value, onChange, disabled }: WorkflowSelectorProps) {
  return (
    <div className="space-y-3">
      <Label className="text-base font-medium">Select Workflow</Label>
      <RadioGroup
        value={value}
        onValueChange={(v) => onChange(v as Workflow)}
        disabled={disabled}
        className="space-y-2"
      >
        {WORKFLOWS.map((workflow) => (
          <div
            key={workflow.value}
            onClick={() => !disabled && onChange(workflow.value)}
            className={`flex items-start space-x-3 rounded-md border p-4 hover:bg-muted/50 transition-colors cursor-pointer ${
              value === workflow.value ? 'border-primary bg-muted/30' : ''
            } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            <RadioGroupItem
              value={workflow.value}
              id={workflow.value}
              className="mt-0.5"
            />
            <div className="flex-1">
              <Label
                htmlFor={workflow.value}
                className="font-medium cursor-pointer"
              >
                {workflow.label}
              </Label>
              <p className="text-sm text-muted-foreground mt-0.5">
                {workflow.description}
              </p>
            </div>
          </div>
        ))}
      </RadioGroup>
    </div>
  )
}
